import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointDropdownProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: string) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointDropdown: React.FC<CheckpointDropdownProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  const options = checkpoint.dropdown ?? [];

  return (
    <FormControl size="small" fullWidth error={Boolean(error)} required={checkpoint.required}>
      <InputLabel>{checkpoint.checkpointName}</InputLabel>
      <Select
        value={typeof value === 'string' ? value : ''}
        onChange={(e) => onChange(e.target.value)}
        label={checkpoint.checkpointName}
        disabled={isReadOnly}
      >
        <MenuItem value="">
          <em>Select…</em>
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
